import { batchConstants } from "../actions/constants/batchConstants";

export const getBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getBatchRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getBatchSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.getBatchFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchCreateRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchCreateSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.batchCreateFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getBatchParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getBatchParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getBatchParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.getBatchParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const deleteBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchDeleteRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchDeleteSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdelete: action.payload
            }
        case batchConstants.batchDeleteFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const toggleBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchToggleRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchToggleSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.batchToggleFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const getAvailableUsersReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getAvailableUsersRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getAvailableUsersSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                availableUsers: action.payload
            }
        case batchConstants.getAvailableUsersFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const viewBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchData: action.payload
            }
        case batchConstants.batchViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getAvailableStudentsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getAvailableStudentsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getAvailableStudentsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                availableStudents: action.payload
            }
        case batchConstants.getAvailableStudentsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const markAttendanceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.attendanceMarkedRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.attendanceMarkedSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                attendance: action.payload
            }
        case batchConstants.attendanceMarkedFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}
